import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';

import { LoadingStatus } from 'src/constants/loading-status';
import { PrCommentJiraIssue, Project } from 'src/redux/jira/types';
import { getJiraSlice } from 'src/selectors/state-slicing-selectors';
import { BucketState } from 'src/types/state';

export const getPullRequestJiraIssuesFetchedStatus = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues.jiraIssuesFetchedStatus
);

export const getPullRequestJiraIssues = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues.jiraIssues
);
export const getIssueTransitionForm = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues.issueTransitionFormData
);

export const getPullRequestJiraIssuesState = createSelector(
  getJiraSlice,
  state => state.pullRequestJiraIssues
);

export const getJiraIssueConnectedSites = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.connectedSites
);

export const getJiraIssueFetchedStatus = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.connectedSitesFetchedStatus
);

export const getPullRequestJiraIssuesForComment = createCachedSelector(
  getPullRequestJiraIssues,
  (_state: BucketState, commentId: number) => commentId,
  (issues: PrCommentJiraIssue[], commentId: number) => {
    return issues.filter(issue => issue.commentId === commentId);
  }
)((_state, commentId: number) => commentId);

export const getPullRequestJiraIssuesByType = createCachedSelector(
  getPullRequestJiraIssues,
  (_state: BucketState, type: string) => type,
  (issues: PrCommentJiraIssue[], type: string) => {
    return issues.filter(issue => issue.type === type);
  }
)((_state, type: string) => type);

export const getCreateJiraIssuePreferences = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.preferences
);

export const getCreatedJiraIssue = createSelector(
  getJiraSlice,
  state => state.createJiraIssue.jiraTabCreateForm.issue
);

export const getIssueMeta = createCachedSelector(
  getJiraSlice,
  (_: BucketState, selectedProject: Project | undefined) => selectedProject,
  (jira, selectedProject) => {
    if (!selectedProject) {
      return {
        issueTypes: [],
        fetchedStatus: LoadingStatus.Before,
      };
    }

    const { issueCreationMetadata } = jira.createJiraIssue;
    const metadataForSiteAndProject = (issueCreationMetadata[
      selectedProject.site.cloudId
    ] || {})[selectedProject.id];

    if (metadataForSiteAndProject) {
      return metadataForSiteAndProject;
    }

    return {
      issueTypes: [],
      fetchedStatus: LoadingStatus.Before,
    };
  }
)((_state, project) => (project ? project.id : 'no-project'));
